import { render, staticRenderFns } from "./SearchFooter.vue?vue&type=template&id=5f994952&scoped=true&"
import script from "./SearchFooter.vue?vue&type=script&lang=js&"
export * from "./SearchFooter.vue?vue&type=script&lang=js&"
import style0 from "./SearchFooter.vue?vue&type=style&index=0&id=5f994952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f994952",
  null
  
)

export default component.exports